<template>
    <div
        class="mx-auto flex h-full min-h-[100dvh] w-full grid-cols-1 flex-col lg:min-h-screen"
    >
        <header
            v-if="!isHideHeader"
            class="top-main-header sticky top-0 z-[52] w-full border-b border-gray-200 bg-white lg:relative"
        >
            <!-- header component need to be responsive -->
            <V2LayoutHeaderTopper />
        </header>
        <!-- header component need to be responsive -->
        <V2LayoutHeaderMenu />
        <main
            class="mx-auto grid w-full flex-1 grid-cols-[62px_minmax(100px,_1fr)] lg:grid-cols-1"
        >
            <div
                class="col-span-full mb-[68px] flex flex-col justify-center lg:mb-0"
                :class="{
                    'col-span-full flex flex-col justify-center':
                        hideSideNavbar,
                }"
            >
                <slot />
            </div>
        </main>

        <footer class="fixed bottom-0 z-50 w-full lg:relative lg:z-[1]">
            <div class="hidden h-full bg-violet-950 lg:flex">
                <V2LayoutFooter />
            </div>

            <div class="flex lg:hidden">
                <LayoutMobileBottomNavbar />
            </div>
        </footer>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useModalStore } from '~/stores'
import { useWindowSize, useElementBounding } from '@vueuse/core'
// import { useAlertStore, useUserStore } from '~/stores'
const route = useRoute()
const { width } = useWindowSize()
const regexUser = new RegExp('/user*')
const arr = [
    regexUser,
    new RegExp('^/news*'),
    new RegExp('/account*'),
    new RegExp('/casino.*[?&]partner=([^&]+)'),
    new RegExp('/games.*[?&]partner=([^&]+)'),
    new RegExp('/setting*'),
    new RegExp('/other*'),
    new RegExp('/help*'),
    new RegExp('/promotions/bonus-100*'),
    new RegExp('/promotions/8-percent*'),
    new RegExp('/promotions'),
]
const useUserStoreInstance = useUserStore()
const { isLoggedIn } = storeToRefs(useUserStoreInstance)

const hideSideNavbar = computed(() => arr.some((i) => i.test(route.fullPath)))

const metaUrl = [
    {
        url: '/',
        name: 'home',
    },
    {
        url: '/help?tab=about-us',
        name: 'about_us',
        queryFullPath: true,
    },
    {
        url: '/help?tab=terms',
        name: 'terms',
        queryFullPath: true,
    },
    {
        url: '/help?tab=policy',
        name: 'policy',
        queryFullPath: true,
    },
    {
        url: '/guides',
        name: 'guides',
    },
    {
        url: '/ca-cuoc-the-thao',
        name: 'sports',
    },
    {
        url: '/esports',
        name: 'e_sports',
    },
    {
        url: '/casino/all',
        name: 'casino',
    },
    {
        url: '/games/jackpot',
        name: 'games_jackpot',
    },
    {
        url: '/games/ingame',
        name: 'games_ingame',
    },
    {
        url: '/games/slots',
        name: 'games_slots',
    },
    {
        url: '/games/fishing',
        name: 'games_shooting',
    },
    {
        url: '/games/instants',
        name: 'games_instant',
    },
    // {
    //     url: '/lottery',
    //     name: 'lottery',
    // },
]
const { t } = useI18n()
const SITE_URL = useRuntimeConfig().public.SITE_URL
const brandName = useRuntimeConfig().public.BRAND_NAME

const seoInfo = () => {
    const metaContent =
        metaUrl.find((i) => {
            if (i.queryFullPath) {
                return i.url === route.fullPath
            }
            return i.url === route.path
        }) || metaUrl[0]
    useSeoMeta({
        title: t(`meta-${metaContent.name}-title`, { brandName }),
        description: t(`meta-${metaContent.name}-description`, { brandName }),
        keywords: t(`meta-${metaContent.name}-keywords`, { brandName }),
        canonical: `${SITE_URL}${route.fullPath}`,
    })
}

// const isBgGray = computed(() => {
//     const { isMobileOrTablet } = useDevice()
//     const listRouter = [
//         '/virtual-sport',
//         '/ca-cuoc-the-thao',
//         '/',
//         '/casino/all?partner=',
//         '/games/fishing?partner=',
//         '/games/cockfight?partner=',
//         '/games/tables?partner=',
//         '/games/slots?partner=',
//         '/lottery',
//         '/games/instants?partner=',
//         '/esports',
//     ]
//     if (listRouter.includes(useRoute().fullPath) && isMobileOrTablet) {
//         return true
//     }
//     return false
// })

watchEffect(() => {
    seoInfo()
})
const arrListHiddenHeader = [
    new RegExp('/casino.*[?&]partner=([^&]+)'),
    new RegExp('/games.*[?&]partner=([^&]+)'),
]
const isHideHeader = computed(() =>
    arrListHiddenHeader.some(
        (i) => i.test(route.fullPath) && width.value < 1024
    )
)

// const useAlertStoreInsatance = useAlertStore()
const useModalStoreInstance = useModalStore()
const {
    showLoginModal,
    showSignUpModal,
    showForgotPasswordModal,
    showGameDenyModal,
    showLogoutModal,
    showVerifyOTPModal,
    showPromoBtiModal,
    showCashbackRebateModal,
} = storeToRefs(useModalStoreInstance)

const showLoggedOutAlert = useState('showLoggedOutAlert', () => false)
// const errorObject = ref({
//     message_key: 'error-logged_out',
//     type: 'ERROR',
// })
watch(
    () => showLoggedOutAlert.value,
    (newVal, _) => {
        if (newVal) {
            // useAlertStoreInsatance.showMessage(errorObject.value)
            showLoggedOutAlert.value = false
        }
    }
)

const openModalRefrral = () => {
    if (route.query.ref && route.query.register && !isLoggedIn.value) {
        showSignUpModal.value = true
    }
}

const sidebarRef = ref(null)
const { top: sidebarReftop } = useElementBounding(sidebarRef)
const hieghOffset = ref(140)
watch(
    () => sidebarReftop.value,
    (newVal) => {
        if (newVal < 75) {
            hieghOffset.value = 140
        } else {
            hieghOffset.value = newVal + 80
        }
    },
    {
        immediate: false,
    }
)
watch(
    () => route.path,
    (newVal) => {
        if (newVal !== '/') {
            hieghOffset.value = 140
        } else {
            hieghOffset.value = newVal + 80
        }
    },
    {
        immediate: true,
    }
)
</script>
